import { useQuery } from 'react-query';

import { getDigestReportsId } from 'api/digestReports/getDigestReportsId';

interface QueryOptions {
  slug: string;
  id: string;
  enabled?: boolean;
  isRefectNeeded?: boolean;
}

export const useGetDigestReportsListId = ({ slug, id, enabled = true }: QueryOptions) => {
  const { data, refetch, isLoading } = useQuery(['digestDocs', slug], () => getDigestReportsId({ slug, id }), {
    refetchOnWindowFocus: false,
    enabled,
  });

  return { data, refetch, isLoading };
};

export default useGetDigestReportsListId;
